// tabs/ChargesTab.jsx - Line charges tab
import React, { useState } from 'react';
import { Box, Grid, Stack, TextInput, Group, Text, NumberInput, Button } from '@mantine/core';

const ChargesTab = ({ selectedLineId }) => {
  const [chargesData, setChargesData] = useState({
    lineSubTotal: 0.00,
    discount: 0.0000,
    discountDollar: 0.00,
    lineNetTotal: 0.00,
    miscTotal: 0.00,
    lineExtTotal: 0.00,
    freight: 0.0000,
    freightDollar: 0.00,
    vlMcAmx: 0.0000,
    vlMcAmxDollar: 0.00,
    packaging: 0.0000,
    packagingDollar: 0.00,
    mtFeeRestock: 0.0000,
    mtFeeRestockDollar: 0.00,
    adgFee: 0.0000,
    adgFeeDollar: 0.00,
    tax: 0.0000,
    taxDollar: 0.00,
    setupFee: 0.00,
    lotCharge: 0.00,
    tooling: 0.00,
    glAccount: '400-00-00-160',
    comp: 1,
    div: '',
    dept: ''
  });

  const handlePercentageChange = (field, value) => {
    setChargesData(prev => ({ ...prev, [field]: value }));
  };

  const handleDollarChange = (field, value) => {
    setChargesData(prev => ({ ...prev, [field]: value }));
  };

  return (
    <Box p="md">
      <Grid gutter="md">
        {/* Left Column */}
        <Grid.Col span={4}>
          <Stack spacing="xs">
            <Group spacing="xs" align="flex-end">
              <Text size="sm" fw={500} w={100}>Line SubTotal:</Text>
              <NumberInput
                value={chargesData.lineSubTotal}
                variant="filled"
                size="sm"
                style={{ flex: 1 }}
                styles={{ input: { textAlign: 'right', fontWeight: 'bold', color: 'blue' } }}
                decimalScale={2}
                fixedDecimalScale
                onChange={(value) => handleDollarChange('lineSubTotal', value)}
              />
              <Text size="sm" fw={500}>$</Text>
            </Group>

            <Group spacing="xs" align="flex-end">
              <Text size="sm" fw={500} w={100}>Discount (%):</Text>
              <NumberInput
                value={chargesData.discount}
                variant="filled"
                size="sm"
                style={{ flex: 1 }}
                styles={{ input: { textAlign: 'right', fontWeight: 'bold', color: 'blue' } }}
                decimalScale={4}
                fixedDecimalScale
                onChange={(value) => handlePercentageChange('discount', value)}
              />
              <Text size="sm" fw={500}>%</Text>
            </Group>

            <Group spacing="xs" align="flex-end">
              <Text size="sm" fw={500} w={100}>Discount ($):</Text>
              <NumberInput
                value={chargesData.discountDollar}
                variant="filled"
                size="sm"
                style={{ flex: 1 }}
                styles={{ input: { textAlign: 'right', fontWeight: 'bold', color: 'blue' } }}
                decimalScale={2}
                fixedDecimalScale
                onChange={(value) => handleDollarChange('discountDollar', value)}
              />
              <Text size="sm" fw={500}>$</Text>
            </Group>

            <Group spacing="xs" align="flex-end">
              <Text size="sm" fw={500} w={100}>Line Net Total:</Text>
              <NumberInput
                value={chargesData.lineNetTotal}
                variant="filled"
                size="sm"
                style={{ flex: 1 }}
                styles={{ input: { textAlign: 'right', fontWeight: 'bold', color: 'blue' } }}
                decimalScale={2}
                fixedDecimalScale
                onChange={(value) => handleDollarChange('lineNetTotal', value)}
              />
              <Text size="sm" fw={500}>$</Text>
            </Group>

            <Group spacing="xs" align="flex-end">
              <Text size="sm" fw={500} w={100}>Misc Total:</Text>
              <NumberInput
                value={chargesData.miscTotal}
                variant="filled"
                size="sm"
                style={{ flex: 1 }}
                styles={{ input: { textAlign: 'right', fontWeight: 'bold', color: 'blue' } }}
                decimalScale={2}
                fixedDecimalScale
                onChange={(value) => handleDollarChange('miscTotal', value)}
              />
              <Text size="sm" fw={500}>$</Text>
            </Group>

            <Group spacing="xs" align="flex-end">
              <Text size="sm" fw={500} w={100}>Line Ext Total:</Text>
              <NumberInput
                value={chargesData.lineExtTotal}
                variant="filled"
                size="sm"
                style={{ flex: 1 }}
                styles={{ input: { textAlign: 'right', fontWeight: 'bold', color: 'blue' } }}
                decimalScale={2}
                fixedDecimalScale
                onChange={(value) => handleDollarChange('lineExtTotal', value)}
              />
              <Text size="sm" fw={500}>$</Text>
            </Group>
          </Stack>
        </Grid.Col>

        {/* Middle Column */}
        <Grid.Col span={4}>
          <Stack spacing="xs">
            <Group spacing="xs" align="flex-end">
              <Text size="sm" fw={500} w={120}>Freight:</Text>
              <NumberInput
                value={chargesData.freight}
                variant="filled"
                size="sm"
                w={80}
                styles={{ input: { textAlign: 'right', fontWeight: 'bold', color: 'blue' } }}
                decimalScale={4}
                fixedDecimalScale
                onChange={(value) => handlePercentageChange('freight', value)}
              />
              <Text size="sm" fw={500}>%</Text>
              <NumberInput
                value={chargesData.freightDollar}
                variant="filled"
                size="sm"
                w={80}
                styles={{ input: { textAlign: 'right', fontWeight: 'bold', color: 'blue' } }}
                decimalScale={2}
                fixedDecimalScale
                onChange={(value) => handleDollarChange('freightDollar', value)}
              />
              <Text size="sm" fw={500}>$</Text>
            </Group>

            <Group spacing="xs" align="flex-end">
              <Text size="sm" fw={500} w={120}>V1/MC/AMX:</Text>
              <NumberInput
                value={chargesData.vlMcAmx}
                variant="filled"
                size="sm"
                w={80}
                styles={{ input: { textAlign: 'right', fontWeight: 'bold', color: 'blue' } }}
                decimalScale={4}
                fixedDecimalScale
                onChange={(value) => handlePercentageChange('vlMcAmx', value)}
              />
              <Text size="sm" fw={500}>%</Text>
              <NumberInput
                value={chargesData.vlMcAmxDollar}
                variant="filled"
                size="sm"
                w={80}
                styles={{ input: { textAlign: 'right', fontWeight: 'bold', color: 'blue' } }}
                decimalScale={2}
                fixedDecimalScale
                onChange={(value) => handleDollarChange('vlMcAmxDollar', value)}
              />
              <Text size="sm" fw={500}>$</Text>
            </Group>

            <Group spacing="xs" align="flex-end">
              <Text size="sm" fw={500} w={120}>Packaging:</Text>
              <NumberInput
                value={chargesData.packaging}
                variant="filled"
                size="sm"
                w={80}
                styles={{ input: { textAlign: 'right', fontWeight: 'bold', color: 'blue' } }}
                decimalScale={4}
                fixedDecimalScale
                onChange={(value) => handlePercentageChange('packaging', value)}
              />
              <Text size="sm" fw={500}>%</Text>
              <NumberInput
                value={chargesData.packagingDollar}
                variant="filled"
                size="sm"
                w={80}
                styles={{ input: { textAlign: 'right', fontWeight: 'bold', color: 'blue' } }}
                decimalScale={2}
                fixedDecimalScale
                onChange={(value) => handleDollarChange('packagingDollar', value)}
              />
              <Text size="sm" fw={500}>$</Text>
            </Group>

            <Group spacing="xs" align="flex-end">
              <Text size="sm" fw={500} w={120}>MT Fee / Restock:</Text>
              <NumberInput
                value={chargesData.mtFeeRestock}
                variant="filled"
                size="sm"
                w={80}
                styles={{ input: { textAlign: 'right', fontWeight: 'bold', color: 'blue' } }}
                decimalScale={4}
                fixedDecimalScale
                onChange={(value) => handlePercentageChange('mtFeeRestock', value)}
              />
              <Text size="sm" fw={500}>%</Text>
              <NumberInput
                value={chargesData.mtFeeRestockDollar}
                variant="filled"
                size="sm"
                w={80}
                styles={{ input: { textAlign: 'right', fontWeight: 'bold', color: 'blue' } }}
                decimalScale={2}
                fixedDecimalScale
                onChange={(value) => handleDollarChange('mtFeeRestockDollar', value)}
              />
              <Text size="sm" fw={500}>$</Text>
            </Group>

            <Group spacing="xs" align="flex-end">
              <Text size="sm" fw={500} w={120}>ADG FEE:</Text>
              <NumberInput
                value={chargesData.adgFee}
                variant="filled"
                size="sm"
                w={80}
                styles={{ input: { textAlign: 'right', fontWeight: 'bold', color: 'blue' } }}
                decimalScale={4}
                fixedDecimalScale
                onChange={(value) => handlePercentageChange('adgFee', value)}
              />
              <Text size="sm" fw={500}>%</Text>
              <NumberInput
                value={chargesData.adgFeeDollar}
                variant="filled"
                size="sm"
                w={80}
                styles={{ input: { textAlign: 'right', fontWeight: 'bold', color: 'blue' } }}
                decimalScale={2}
                fixedDecimalScale
                onChange={(value) => handleDollarChange('adgFeeDollar', value)}
              />
              <Text size="sm" fw={500}>$</Text>
            </Group>

            <Group spacing="xs" align="flex-end">
              <Text size="sm" fw={500} w={120}>Tax:</Text>
              <NumberInput
                value={chargesData.tax}
                variant="filled"
                size="sm"
                w={80}
                styles={{ input: { textAlign: 'right', fontWeight: 'bold', color: 'blue' } }}
                decimalScale={4}
                fixedDecimalScale
                onChange={(value) => handlePercentageChange('tax', value)}
              />
              <Text size="sm" fw={500}>%</Text>
              <NumberInput
                value={chargesData.taxDollar}
                variant="filled"
                size="sm"
                w={80}
                styles={{ input: { textAlign: 'right', fontWeight: 'bold', color: 'blue' } }}
                decimalScale={2}
                fixedDecimalScale
                onChange={(value) => handleDollarChange('taxDollar', value)}
              />
              <Text size="sm" fw={500}>$</Text>
            </Group>
          </Stack>
        </Grid.Col>

        {/* Right Column */}
        <Grid.Col span={4}>
          <Stack spacing="md">
            {/* Additional Line Prices Section */}
            <Box>
              <Text size="sm" fw={500} mb="xs">Additional Line Prices</Text>
              <Stack spacing="xs">
                <Group spacing="xs" align="flex-end">
                  <Text size="sm" fw={500} w={80}>Setup Fee:</Text>
                  <NumberInput
                    value={chargesData.setupFee}
                    variant="filled"
                    size="sm"
                    style={{ flex: 1 }}
                    styles={{ input: { textAlign: 'right', fontWeight: 'bold', color: 'blue' } }}
                    decimalScale={2}
                    fixedDecimalScale
                    onChange={(value) => handleDollarChange('setupFee', value)}
                  />
                  <Text size="sm" fw={500}>EA</Text>
                </Group>

                <Group spacing="xs" align="flex-end">
                  <Text size="sm" fw={500} w={80}>Lot Charge:</Text>
                  <NumberInput
                    value={chargesData.lotCharge}
                    variant="filled"
                    size="sm"
                    style={{ flex: 1 }}
                    styles={{ input: { textAlign: 'right', fontWeight: 'bold', color: 'blue' } }}
                    decimalScale={2}
                    fixedDecimalScale
                    onChange={(value) => handleDollarChange('lotCharge', value)}
                  />
                  <Text size="sm" fw={500}>EA</Text>
                </Group>

                <Group spacing="xs" align="flex-end">
                  <Text size="sm" fw={500} w={80}>Tooling:</Text>
                  <NumberInput
                    value={chargesData.tooling}
                    variant="filled"
                    size="sm"
                    style={{ flex: 1 }}
                    styles={{ input: { textAlign: 'right', fontWeight: 'bold', color: 'blue' } }}
                    decimalScale={2}
                    fixedDecimalScale
                    onChange={(value) => handleDollarChange('tooling', value)}
                  />
                  <Text size="sm" fw={500}>EA</Text>
                </Group>
              </Stack>
            </Box>

            {/* GL Account Section */}
            <Box>
              <Text size="sm" fw={500} mb="xs">GL Account</Text>
              <Group spacing="xs" align="flex-end">
                <TextInput
                  value={chargesData.glAccount}
                  variant="filled"
                  size="sm"
                  style={{ flex: 1 }}
                  styles={{ input: { fontWeight: 'bold', color: 'blue' } }}
                  onChange={(e) => setChargesData(prev => ({ ...prev, glAccount: e.target.value }))}
                />
                <Button variant="default" size="sm" style={{ padding: '0 8px' }}>
                  📋
                </Button>
              </Group>
            </Box>

            {/* Bottom Fields */}
            <Group spacing="md" mt="md">
              <Group spacing="xs" align="flex-end">
                <Text size="sm" fw={500}>Comp:</Text>
                <NumberInput
                  value={chargesData.comp}
                  variant="filled"
                  size="sm"
                  w={60}
                  styles={{ input: { fontWeight: 'bold', color: 'blue' } }}
                  onChange={(value) => setChargesData(prev => ({ ...prev, comp: value }))}
                />
              </Group>

              <Group spacing="xs" align="flex-end">
                <Text size="sm" fw={500}>Div:</Text>
                <TextInput
                  value={chargesData.div}
                  variant="filled"
                  size="sm"
                  w={80}
                  onChange={(e) => setChargesData(prev => ({ ...prev, div: e.target.value }))}
                />
              </Group>

              <Group spacing="xs" align="flex-end">
                <Text size="sm" fw={500}>Dept:</Text>
                <TextInput
                  value={chargesData.dept}
                  variant="filled"
                  size="sm"
                  w={80}
                  onChange={(e) => setChargesData(prev => ({ ...prev, dept: e.target.value }))}
                />
              </Group>
            </Group>
          </Stack>
        </Grid.Col>
      </Grid>
    </Box>
  );
};

export default ChargesTab;